import { render } from "./Spinner.vue?vue&type=template&id=6ce8c224&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=6ce8c224&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ce8c224"

export default script